import { Cog } from "lucide-react";

export default function IntroductionPropertyPanel() {
  return (
    <div className="h-full flex flex-col items-center justify-center p-4 text-center">
      <div className="size-12 flex items-center justify-center rounded-full bg-primary">
        <Cog className="size-6 text-white" />
      </div>

      <div className="mt-4 text-balance font-medium">Propriedades do nó</div>

      <div className="mt-1 w-2.5/3 text-xs text-card/40 font-medium leading-normal">
        Aqui você pode visualizar e editar as propriedades do nó selecionado.
      </div>

      <div className="mt-8 w-full text-xs text-card/40 font-medium italic">
        Selecione um nó da lista acima para visualizar suas propriedades.
      </div>
    </div>
  );
}
